var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgErrorPageMaskDesktop = function SvgErrorPageMaskDesktop(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 845.595,
    height: 768,
    viewBox: "0 0 845.595 768",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f7bed1;}.b{fill:#1a2269;}.c{fill:#14165e;}.d{fill:#363896;}.e{fill:#24277e;}.f{fill:#070939;}.g{fill:#040518;}.h{fill:#f86f6f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-520.858)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2322.284,0V768H1813.4c29.306-58.836,75.758-109.142,133.867-140.033,33.089-17.59,69.026-29.208,102.665-45.725s65.988-39.113,84.1-71.918,18.49-77.477-6.982-104.964c-24.727-26.686-65.182-30.626-101.539-29.311s-74.621,5.782-107.551-9.684c-60.386-28.358-74.7-107.846-120.761-156.113-31.934-33.466-77.448-49.99-121.975-62.525s-90.708-22.55-130.116-46.774C1509.121,78.833,1479.208,41.467,1476.69,0Z",
    transform: "translate(-955.832)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(771.869 132.593)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 301.231)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2788.392,2045.34v124.169a38.97,38.97,0,0,1-38.923,38.926H2561.493a28.967,28.967,0,0,0-28.937,28.937v85.087h-9.986v-85.087a38.966,38.966,0,0,1,38.923-38.923h187.975a28.972,28.972,0,0,0,28.935-28.939V2045.34Z",
    transform: "translate(-2522.57 -1988.282)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(222.233 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M3574.19,2173.608v19.9a8.6,8.6,0,0,1-8.6,8.6h-15.254a8.579,8.579,0,0,1-6.545-3.022v0a8.561,8.561,0,0,1-2.055-5.578v-19.9Z",
    transform: "translate(-3519.368 -2085.766)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 32.706)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M3537.454,1980.336v39.748a11.115,11.115,0,0,1-11.117,11.114H3482.2a11.115,11.115,0,0,1-11.115-11.114v-39.748Z",
    transform: "translate(-3465.677 -1971.585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 77.188,
    height: 8.751,
    rx: 4.376,
    transform: "translate(77.188 8.751) rotate(180)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M3532.034,1840.3h-11.311v-27.051a5.655,5.655,0,0,1,5.656-5.655h0a5.655,5.655,0,0,1,5.655,5.655Z",
    transform: "translate(-3503.399 -1807.598)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M5.655,0h0a5.655,5.655,0,0,1,5.655,5.655V32.706a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V5.655A5.655,5.655,0,0,1,5.655,0Z",
    transform: "translate(48.554 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M3537.454,1980.336v39.748a11.115,11.115,0,0,1-11.117,11.114H3482.2a11.115,11.115,0,0,1-11.115-11.114c47.656-3.311,52.033-39.748,52.033-39.748Z",
    transform: "translate(-3465.677 -1938.879)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 66.366,
    height: 3.205,
    transform: "translate(5.411 41.457)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M3614.3,2050.337v22.948a11.115,11.115,0,0,1-11.117,11.114H3572.2C3603.486,2084.4,3614.3,2050.337,3614.3,2050.337Z",
    transform: "translate(-3542.52 -1992.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 32.456,
    height: 2.077,
    transform: "translate(22.366 92.319)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 11.311,
    height: 3.96,
    transform: "translate(17.324 28.746)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 11.311,
    height: 3.96,
    transform: "translate(48.554 28.746)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M3580.7,2192.262v15.422a8.6,8.6,0,0,1-8.6,8.6h-15.255a8.579,8.579,0,0,1-6.545-3.021v0c23.777,2.917,27.408-21,27.408-21Z",
    transform: "translate(-3525.875 -2099.943)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(222.233)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3927.291,552.47v9.986H3627.466a28.967,28.967,0,0,0-28.937,28.937V722.616h-9.989V591.393a38.968,38.968,0,0,1,38.926-38.923Z",
    transform: "translate(-3554.94 -552.47)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 130.407)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M3574.19,1124.333v-19.9a8.6,8.6,0,0,0-8.6-8.6h-15.254a8.58,8.58,0,0,0-6.545,3.021v0a8.563,8.563,0,0,0-2.055,5.579v19.9Z",
    transform: "translate(-3519.368 -1095.832)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 24.024)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M3537.454,1246.794v-39.748a11.116,11.116,0,0,0-11.117-11.114H3482.2a11.115,11.115,0,0,0-11.115,11.114v39.748Z",
    transform: "translate(-3465.677 -1195.932)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 77.188,
    height: 8.751,
    rx: 4.376,
    transform: "translate(77.188 59.613) rotate(180)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M3537.454,1246.794v-39.748a11.116,11.116,0,0,0-11.117-11.114H3482.2a11.115,11.115,0,0,0-11.115,11.114c47.656,3.311,52.033,39.748,52.033,39.748Z",
    transform: "translate(-3465.677 -1171.908)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 66.366,
    height: 3.205,
    transform: "translate(5.411 71.681)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M3614.3,1229.994v-22.948a11.116,11.116,0,0,0-11.117-11.114H3572.2C3603.486,1195.932,3614.3,1229.994,3614.3,1229.994Z",
    transform: "translate(-3542.52 -1171.908)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 32.456,
    height: 2.077,
    transform: "translate(22.366 21.947)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M3580.7,1119.856v-15.422a8.6,8.6,0,0,0-8.6-8.6h-15.255a8.58,8.58,0,0,0-6.545,3.021v0c23.777-2.916,27.408,21,27.408,21Z",
    transform: "translate(-3525.875 -1095.832)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(150.398 196.462)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 46.631)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M3172.608,1571.017h-20.55a2.829,2.829,0,0,1,0-5.658h20.55a2.829,2.829,0,0,1,0,5.658Z",
    transform: "translate(-3149.23 -1565.359)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.631)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M3346.356,1397.269a2.829,2.829,0,0,1-2.829-2.829v-20.55a2.829,2.829,0,1,1,5.657,0v20.55A2.829,2.829,0,0,1,3346.356,1397.269Z",
    transform: "translate(-3343.527 -1371.062)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.658 13.658)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M3223.083,1447.745a2.82,2.82,0,0,1-2-.829l-14.117-14.116a2.829,2.829,0,0,1,4-4l14.116,14.117a2.829,2.829,0,0,1-2,4.829Z",
    transform: "translate(-3206.137 -1427.971)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168.568 115.932)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.082)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M3963.1,1854.11h20.55a2.829,2.829,0,0,1,0,5.658H3963.1a2.829,2.829,0,0,1,0-5.658Z",
    transform: "translate(-3960.271 -1854.11)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 26.082)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M3854.427,1962.784a2.829,2.829,0,0,1,2.829,2.829v20.55a2.829,2.829,0,0,1-5.657,0v-20.55A2.829,2.829,0,0,1,3854.427,1962.784Z",
    transform: "translate(-3851.598 -1962.784)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.857 18.857)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M3933,1932.68a2.821,2.821,0,0,1,2,.828l14.116,14.117a2.829,2.829,0,0,1-4,4L3931,1937.509a2.829,2.829,0,0,1,2-4.829Z",
    transform: "translate(-3930.168 -1932.68)"
  }))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgErrorPageMaskDesktop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/error-page-mask-desktop.23a8dfad57c54efa8944273d0e3904f3.svg";